<template>
  <div class="main">
    <icon name="loading" v-if="status === 0" />
    <icon name="check-circle" v-if="status === 1" />
    <icon name="close-circle" v-if="status === 2" />
    <div class="cont" v-if="status === 0">
      正在保存
      <span class="info">{{ packageName }}</span>
      请稍后
    </div>
    <div class="cont between" v-if="status === 1">
      <div>
        <span class="info">{{ packageName }}</span>
        保存成功
      </div>
      <t-button variant="text" size="medium" class="link" @click="handleJump">查看用户包</t-button>
    </div>
    <div class="hide" @click="handleClose" v-if="status === 0">隐藏</div>
  </div>
</template>

<script>
import router from '@/router';

export default {
  props: {
    status: {
      type: Number,
    },
    packageId: {
      type: [Number, String],
    },
    packageName: {
      type: String,
    },
    callback: {
      type: Function,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleClose() {
      // eslint-disable-next-line no-unused-expressions
      this.callback && this.callback();
    },
    handleJump() {
      // eslint-disable-next-line no-unused-expressions
      this.callback && this.callback();
      router.push({
        name: 'customAnalysisBookmarkList',
        query: {
          openCrowd: true,
        },
      });
    },
  },
};
</script>
<style lang="less">
.save-crowd-message-container {
  background-color: white !important;
  padding: 2px 2px 2px 7px !important;

  .main {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .hide {
      position: absolute;
      right: 5px;
      top: 15px;
      color: #5a66ff;
      cursor: pointer;
    }
  }

  .el-message__icon {
    display: none;
  }

  .cont {
    display: flex;
    align-items: center;
    margin-left: 15px;
    width: 100%;

    .info {
      line-height: 50px;
      font-weight: bold;
      color: black;
      margin-left: 10px;
      margin-right: 10px;
    }

    .link {
      float: right;
    }
  }

  .between {
    justify-content: space-between;
  }
}
</style>
